<template>
  <section class="section">
    <div class="content">
      <h1 class="title">
        Dictionary
      </h1>

      <p>
        <back-button />
      </p>

      <p>This is a work in progress...</p>
    </div>

    <div class="columns">
      <div class="column">
        <div class="field has-addons">
          <div class="control is-expanded">
            <input class="input" type="text" v-model="query" placeholder="Query word">
          </div>
          <div class="control">
            <a class="button is-info" @keyup.enter="search()" @click="search()">
              Search
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-one-third" v-html="merriamWebsterResult"></div>
      <div class="column is-one-third" v-html="googleTranslateResult"></div>
      <div class="column is-one-third" v-html="lingueeResult"></div>
    </div>
  </section>
</template>

<script>
import BackButton from '@/components/pages/BackButton'

/* eslint-disable */
export default {
  components: {
    BackButton
  },
  data () {
    return {
      query: '',
      merriamWebsterResult: '',
      googleTranslateResult: '',
      lingueeResult: ''
    }
  },
  methods: {
    search () {
      this.merriamWebsterResult = this.createIframe('https://www.merriam-webster.com/dictionary/' + encodeURI(this.query))
      this.googleTranslateResult = this.createIframe('https://translate.google.com/#en/pt/' + encodeURI(this.query))
      this.lingueeResult = this.createIframe('https://www.linguee.com.br/ingles-portugues/search?source=ingles&query=' + encodeURI(this.query))
    },
    createIframe (url) {
      return `<iframe src="${url}" style="width: 100%; height: 500px;"></iframe>`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/DictionaryPage.vue